/**
 * Storage key for the Supervised-POS cart snapshot.
 *
 * When a branch runs POS in supervised mode, the cashier's in-progress
 * ticket is persisted to localStorage so it survives a reload (F5), a
 * logout → re-login, AND a full browser restart — because the key is on
 * the logout preserve allowlist. The key is scoped PER USER so a
 * different operator (or an impersonation swap) never restores someone
 * else's ticket.
 *
 * Single source of truth for the prefix: pos.page writes/reads the key,
 * and auth.store's logout snapshots any localStorage key with this
 * prefix before `localStorage.clear()` so the ticket is not dropped on
 * logout.
 */
export const SUPERVISED_CART_KEY_PREFIX = 'neo-pos-supervised-cart:';

export const buildSupervisedCartKey = (userId: string): string =>
  `${SUPERVISED_CART_KEY_PREFIX}${userId}`;
